var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products.length > 1)?_c('div',{staticClass:"iconGroup",style:(_vm.generateStyles())},_vm._l((_vm.products),function(product){return _c('Icon',{key:product,attrs:{"name":product,"is-active":_vm.activeProducts.includes(product)}})}),1):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ec22fc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/components/ProductIndicator.vue
// module id = 1IEc
// module chunks = 4